exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".subtradezone-form .btn-success[data-v-4e54dc77]{float:right}.card-footer[data-v-4e54dc77]{margin-left:0!important}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/views/admin/tradezone/FormSubTradezone.vue"],"names":[],"mappings":"AACA,iDACI,WAAa,CAChB,AACD,8BACE,uBAA2B,CAC5B","file":"FormSubTradezone.vue","sourcesContent":["\n.subtradezone-form .btn-success[data-v-4e54dc77] {\n    float: right;\n}\n.card-footer[data-v-4e54dc77] {\n  margin-left: 0px!important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e54dc77","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/admin/tradezone/FormSubTradezone.vue
// module id = 1900
// module chunks = 0